import { PaletteMode } from '@mui/material';
import tokens from '@skodaflow/web-tokens/src/tokens.json';

const skodaColors = tokens['flow-colors'];

export const createPaletteLight = () => ({
	mode: 'light' as PaletteMode,
	skodaColors,
	secondary: { main: '#78FAAE', light: '#A8FFCC' },
	primary: { main: '#419468' },
	tertiary: { main: '#0E3A2F' },
	error: { main: '#E82B37' },
	action: { disabled: skodaColors['neutrals-chrome200'] },
	text: {
		primary: skodaColors.text,
		secondary: '#464748',
		disabled: skodaColors['neutrals-chrome200']
	},
	background: {
		default: '#f2f2f2',
		paper: skodaColors.background,
		selected: 'rgba(0, 0, 0, 0.055)'
	},
	formControlLabel: '#7C7D7E',
	dropdownIcon: skodaColors.text,
	skodaLinkIcon: skodaColors.text,
	closeButton: {
		background: '#E4E4E4',
		color: skodaColors.text
	},
	scrollbar: {
		dark: '#C4C6C7',
		light: '#C4C6C788'
	},
	bulletPoints: skodaColors.text,
	chip: {
		backgroundPrimary: '#E8FFF1',
		backgroundSecondary: 'rgba(22, 23, 24, 0.06)',
		colorPrimary: '#419468',
		colorSecondary: skodaColors.text,
		colorPrimaryHover: '#59BC87',
		colorSecondaryHover: '#5A5B5C'
	}
});
